import {useFormik} from 'formik';
import {useState} from 'react';
import {CreateBlockDTO, useBlocks} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseAddBlockFormProps = {
  setOpen: (open: boolean) => void;
};

export const useAddBlockForm = ({setOpen}: UseAddBlockFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {createBlockMutation} = useBlocks();

  const onSubmit = async (values: CreateBlockDTO) => {
    setErrorMessage(null);
    try {
      await createBlockMutation.mutateAsync(values);
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при создании блока');
    }
  };

  const formik = useFormik({
    initialValues: {
      title: '',
      name: '',
    },
    validationSchema: Yup.object({
      title: Yup.string().max(256, 'Заголовок не должен превышать 256 символов').required('Заголовок обязателен'),
      name: Yup.string().max(64, 'Название не должно превышать 64 символа').required('Название обязательно'),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createBlockMutation.isPending,
    submitError: createBlockMutation.error
      ? (createBlockMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};
